<template>
    <div class="modal" id="helpcenterModal" tabindex="-1" role="dialog" aria-labelledby="helpcenterModal" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content p-2 p-sm-5">
                <div class="modal-header">
                    <h5 class="modal-title text-dark text-center" id="helpcenterModalLabel">
                        <h3>Fragen zum Auto-Abo?</h3>
                    </h5>

                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times-circle text-dark"></i>
                    </button>
                </div>
                <div class="modal-body text-dark text-center">
                    <div class="col-sm-11 col-12" style="margin: 0 auto;">
                        <div v-if="navbarModalPhoneNumber == true">
                            <div class="m-3">Ruf uns einfach an</div>

                            <a href="tel:+4993026570570">
                                <grey-button class="info-boxes-grey">
                                    <div class="row w-100">
                                        <div class="col-2 text-center gx-0 d-flex align-items-center justify-content-center">
                                            <i class="fal fa-phone icon-size" alt="phone icon navbar"></i>
                                        </div>

                                        <div class="col-10 gx-0 fs-3">
                                            <div class="font-big-title">
                                                093 02 / 657 057 0
                                            </div>
                                            <div class="text-muted font-small-title">Mo. - Fr. · 09:00 - 17:00 Uhr</div>
                                        </div>
                                    </div>
                                </grey-button>
                            </a>

                            <seperator-x class="mt-5 mb-5"/>
                        </div>

                        <div @click="redirect('foldout')">
                            <grey-button class="info-boxes-grey container">
                                <div class="row w-100 min-height">
                                    <div class="col-2 text-center gx-0 d-flex align-items-center justify-content-center">
                                        <i class="fab fa-whatsapp icon-size icon-whatsapp" alt="whatsapp icon"></i>
                                    </div>
                                    <div class="col-10 gx-0 fs-3 font-big-title word-break d-flex align-items-center justify-content-center">
                                        Schreib uns per Whatsapp
                                    </div>
                                </div>
                                <div>
                                    <div v-if="qrCode" class="d-none d-md-block">
                                        <div class=" text-muted mt-1 mb-1"><small>Whatsapp öffnen</small></div>
                                            <div class="col-12 mb-2">
                                                <whats-app-qr />
                                            </div>
                                            <button
                                            type="button"
                                            class="btn btn-outline-success mt-2 mb-2"
                                            @click.stop="redirect('whatsapp')"
                                        >
                                            zu Whatsapp
                                        </button>
                                    </div>
                                </div>
                                <div class="d-block d-md-none mb-2" id="whatsapp-breakpoint"></div>
                            </grey-button>
                        </div>
                        <seperator-x class="mt-5 mb-5"/>

                        <div class="m-3">Schreib uns eine E-Mail</div>

                        <a href="mailto:kundenservice@faaren.com">
                            <grey-button class="info-boxes-grey mb-5">
                                <div class="row w-100">
                                    <div class="col-2 text-center gx-0 d-flex align-items-center justify-content-center">
                                        <i class="fal fa-envelope icon-size" alt="email icon navbar"></i>
                                    </div>

                                    <div class="col-10 gx-0 fs-3 font-big-title word-break d-flex align-items-center justify-content-center">
                                        kundenservice@faaren.com
                                    </div>
                                </div>
                            </grey-button>
                        </a>
                        <seperator-x class="mt-5 mb-5"/>

                        <div class="m-3">Besuche uns auf Social Media</div>
                        <grey-button class="info-boxes-grey mb-5">
                            <div class="row w-100">
                                <div class="w-100 d-flex justify-content-around align-items-center">
                                    <i
                                        class="fab fa-instagram icon-size click-pointer"
                                        alt="instagram icon "
                                        @click="redirect('instagram')"
                                    ></i>
                                    <i
                                        class="fab fa-facebook icon-size click-pointer"
                                        alt="facebook icon "
                                        @click="redirect('facebook')"
                                    ></i>
                                    <i
                                        class="fab fa-linkedin icon-size click-pointer"
                                        alt="linkedin icon "
                                        @click="redirect('linkedin')"
                                    ></i>
                                </div>
                            </div>
                        </grey-button>

                        <div class="text-muted mb-2">Unser Aufkommen ist im Moment sehr hoch. Kontaktiere uns daher gerne via Whatsapp.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import whatsAppQr from '../atoms/texts/WhatsAppQr.vue'
    export default {
        name: "ContactModal",

        components: {
            whatsAppQr
        },

        props: {
            navbarModalPhoneNumber: {
                default: false,
            }
        },

        data() {
            return {
                qrCode: false,
            };
        },
        methods: {
            redirect(link) {
                let hiddenDiv = document.querySelector('#whatsapp-breakpoint')

                switch (link) {
                    case 'foldout':
                        if (hiddenDiv && window.getComputedStyle(hiddenDiv).display != 'none') {
                            window.open('https://wa.me/+4993026570570', '', 'noopener,noreferrer')
                        }
                        this.qrCode = !this.qrCode
                        break
                    case 'email':
                        window.open('mailto:' + config.public.contact.email.support)
                        break
                    case 'whatsapp':
                        window.open('https://wa.me/+4993026570570', '', 'noopener,noreferrer')
                        break
                    case 'phone':
                        window.open('tel:+4993026570570')
                        break
                    case 'instagram':
                        window.open('https://www.instagram.com/drivefaaren', '', 'noopener,noreferrer')
                        break
                    case 'facebook':
                        window.open('https://www.facebook.com/drivefaaren', '', 'noopener,noreferrer')
                        break
                    case 'linkedin':
                        window.open('https://www.linkedin.com/company/faaren/', '', 'noopener,noreferrer')
                        break
                }
            },
        },
    }
</script>

<style scoped>
.font-big-title {
    font-weight: bold;
    line-height: 1em;
}
.font-small-title {
    font-size: .8em;
}
.modal-content {
    border: unset;
    -webkit-border-radius: 0px !important;
    -moz-border-radius: 0px !important;
    border-radius: 0px !important;
}
.modal-header {
    border-bottom: unset;
}
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.circle {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    position: relative;
    background-color: #f2f2f2;
    display: flex;
    justify-content: center;
    align-items: center;
}
.icon-size {
    font-size:
    x-large;
}
.line {
    width: 2px;
    height: 30px;
    border: 2px dashed #f2f2f2;
}
.info-boxes-grey {
    cursor: pointer;
    margin: 0 auto;
    min-height: 65px;
}
.icon-whatsapp {
    color: #36acbb;
    font-size: 30px;
}
.modal-body a{
    text-decoration: none;
    color: inherit;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    font: inherit;
}
.modal-dialog {
    border-radius: 0 !important;
}
.min-height{
    min-height: 60px;
}
.link-red {
    color: rgb(159, 33, 33) !important;
}
.word-break {
    word-break: break-all;
}
</style>
